<template>
  <div class="row border-bottom">
    <div
      class="col-10 text-start menu-section"
      @click="toggleCurrentEdit('setting')"
    >
      <h5>{{ $t("Menu.list.stones.group.formSetting.setting") }}</h5>
      <p v-if="currentEdit != 'setting'">
        {{ currentSetting }}
      </p>
    </div>
    <div class="col-2 text-end">
      <img
        :src="appUrl + '/img/icons/edit.svg'"
        class="icon open"
        @click="toggleCurrentEdit('setting')"
        v-if="currentEdit != 'setting'"
      />
      <img
        :src="appUrl + '/img/icons/close.svg'"
        class="icon"
        @click="toggleCurrentEdit('setting')"
        v-else
      />
    </div>
    <div class="col-12 text-center" v-if="currentEdit == 'setting'">
      <ul class="default-option-list">
        <template v-for="(item, index) in possibleItems.list.settings">
          <li v-if="item.match" v-bind:key="index" class="pointer match">
            <img
              class="thumb"
              @error="$parent.$parent['setIconNotAvailable']($refs[item.id])"
              :ref="item.id"
              :src="getImage(item.id, false)"
              :srcset="getImage(item.id, true)"
            />
            <p>{{ item.text }}</p>
          </li>
        </template>
        <template v-for="(item, index) in settingsList">
          <li
            v-if="!item.match"
            v-bind:key="'setting-' + index"
            @click="
              changeItemByVarValue(
                'type_' +
                  possibleItems.groupId +
                  '_' +
                  possibleItems.stoneId +
                  '_' +
                  item.id
              )
            "
            class="pointer"
          >
            <img
              class="thumb"
              @error="$parent.$parent['setIconNotAvailable']($refs[item.id])"
              :ref="item.id"
              :src="getImage(item.id, false)"
              :srcset="getImage(item.id, true)"
            />
            <p>{{ item.text }}</p>
          </li>
        </template>
        <li
          v-if="
            form.show != 'setting' &&
            possibleItems.list.settings.length > form.maxItems
          "
          @click="form.show = 'setting'"
        >
          <img :src="appUrl + '/img/icons/next.svg'" class="ring" />
          {{ $t("Menu.list.stones.group.formSetting.add") }} &gt;
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "Setting",
  props: ["possibleItems", "currentEdit", "itemData", "stoneId", "groupId"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      imageHost: process.env.VUE_APP_IMAGE_HOST,
      form: {
        show: "setting",
        maxItems: 99,
      },
    };
  },
  computed: {
    settingsList: function () {
      let list = [];

      if (typeof this.possibleItems.list.settings == "object") {
        for (let key in this.possibleItems.list.settings) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.possibleItems.list.settings,
              key
            )
          ) {
            if (
              (list.length < this.form.maxItems ||
                this.form.show === "setting") &&
              this.possibleItems.list.settings[key].match == false
            ) {
              list.push(this.possibleItems.list.settings[key]);
            }
          }
        }
      }
      return list;
    },
    currentSetting: function () {
      if (typeof this.possibleItems.list.settings == "object") {
        for (let key in this.possibleItems.list.settings) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.possibleItems.list.settings,
              key
            )
          ) {
            if (this.possibleItems.list.settings[key].match == true) {
              return this.possibleItems.list.settings[key].text;
            }
          }
        }
      }

      return "";
    },
  },
  methods: {
    toggleCurrentEdit: function (id) {
      this.$parent.toggleCurrentEdit(id);
    },
    changeItemByVarValue: function (varValue) {
      this.$parent.changeItemByVarValue(varValue);
    },
    getImage: function (id, isRetina) {
      if (isRetina) {
        return (
          this.appUrl +
          "/img/assets/stones/settings/" +
          id.toUpperCase() +
          "_g@2x.jpg"
        );
      } else {
        return (
          this.appUrl +
          "/img/assets/stones/settings/" +
          id.toUpperCase() +
          "_g.jpg"
        );
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .menu-section {
    cursor: pointer;
  }

  label {
    font-weight: normal;
    line-height: 2.2em;
  }

  .text-bold {
    font-weight: bold;
  }

  img.ring {
    display: block;
    width: 5em;
    height: 5em;
    border-radius: 5em;
    border: solid 0.1rem $brandDarkGrey;
    margin: auto;
    margin-bottom: 0.5em;
  }

  .input-group input,
  .input-group select {
    height: 2.5em;
  }
}
</style>
